import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import cx from 'classnames';
import Button from 'wonderbly-components/lib/Button';
import { prismicImage } from 'src/common/utils/prismic-image';
import TextField from 'wonderbly-components/lib/TextField';
import FieldError from '../UserForm/Field/FieldError';
import Icon from 'wonderbly-components/lib/Icon';

import './SaveForLater.scss';

const SaveForLater = (props) => {
  let {
    label,
    closeButton,
    image,
    title,
    description,
    emailPlaceholder,
    submitButtonText,
    confirmationButtonText,
    confirmationDescription,
    confirmationImage,
    confirmationTitle,
  } = props.data;

  if (props.isSubmitted) {
    title = confirmationTitle;
    image = confirmationImage;
    description = confirmationDescription;
    submitButtonText = confirmationButtonText;
    image.alt = confirmationImage.alt;
  };

  const { errors } = props;

  return (
    <React.Fragment>
      <Button
        onClick={props.handleToggle}
        raised={props.ctaStyle === 'raised'}
        outlined={props.ctaStyle === 'outlined'}
        colour={props.ctaBackgroundColor}
        className="save-for-later__toggle-button">
        <span>
          <Icon icon={props.ctaIcon} />
        </span>
        {props.ctaText}
      </Button>
      {props.isOpen &&
        <div className={cx('save-for-later', {
          'save-for-later--open': props.isOpen,
        })}>
          <div className="save-for-later__label-wrapper">
            <span className="save-for-later__label">{label}</span>
            <button
              className="save-for-later__close-button text-micro"
              onClick={props.handleToggle}>
              {closeButton}
            </button>
          </div>
          <div className="save-for-later__content">
            {image && !isEmpty(image) &&
              <img src={prismicImage(image)} alt={image.alt} />
            }
            <div className="save-for-later__title">{title}</div>
            <div className="save-for-later__description">{description}</div>
            {!props.isSubmitted &&
              <TextField
                type="text"
                name="email"
                id="email"
                placeholder={emailPlaceholder}
                onChange={props.handleEmailChange}
                value={props.values && props.values.email}
              />
            }
            <FieldError message={errors.email} visible={errors.email} />
            <Button
              colour="green"
              type="submit"
              onClick={!props.isSubmitted ? props.handleSubmit : props.handleToggle}
              disabled={props.isSubmitting}>
              {submitButtonText}
            </Button>
          </div>
        </div>
      }
    </React.Fragment>
  );
};

SaveForLater.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  data: PropTypes.shape({
    label: PropTypes.string.isRequired,
    closeButton: PropTypes.string.isRequired,
    image: PropTypes.object,
    title: PropTypes.string,
    description: PropTypes.string,
    emailPlaceholder: PropTypes.string,
    submitButtonText: PropTypes.string.isRequired,
    confirmationButtonText: PropTypes.string.isRequired,
    confirmationDescription: PropTypes.string,
    confirmationImage: PropTypes.object,
    confirmationTitle: PropTypes.string,
  }),
  onCloseSaveForLater: PropTypes.func,
  handleChange: PropTypes.func,
  handleSubmit: PropTypes.func,
  values: PropTypes.shape({
    email: PropTypes.string,
  }),
  errors: PropTypes.shape({
    email: PropTypes.string,
  }),
  isSubmitted: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  ctaIcon: PropTypes.string,
  ctaText: PropTypes.string,
  ctaIconGlobalContent: PropTypes.string.isRequired,
  ctaTextGlobalContent: PropTypes.string.isRequired,
  ctaStyle: PropTypes.string,
  ctaBackgroundColor: PropTypes.string,
  handleToggle: PropTypes.func,
  handleEmailChange: PropTypes.func,
};

export default SaveForLater;



// WEBPACK FOOTER //
// ./src/client/js/view/components/SaveForLater/SaveForLater.js